import { FC, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "../../button/button";

import { useTheme } from "app/shared";
import styles from "./IdoCompleteModal.module.scss";

interface PopupTextItem {
  label: string;
  value: string;
}

interface IIdoCompleteModal {
  popupText?: PopupTextItem[];
  isIdoFinished: boolean;
}

const IdoCompleteModal: FC<IIdoCompleteModal> = ({
  popupText,
  isIdoFinished,
}) => {
  const [visible, setVisible] = useState(false);
  const [currentPopup, setCurrentPopup] = useState<PopupTextItem | null>(null);
  const history = useHistory();
  const { theme } = useTheme();

  useEffect(() => {
    if (isIdoFinished && popupText && popupText.length > 0) {
      setCurrentPopup(popupText[0]);
      setVisible(true);
    }
  }, [isIdoFinished, popupText]);

  const handleRedirect = () => {
    if (currentPopup?.label) {
      history.push(`/ido/${currentPopup?.label}`);
      setVisible(false);
    }
  };

  const handleClose = () => {
    setVisible(false);
  };

  const formatText = (text: string) => {
    return text.replace(
      /\$12M FDV/g,
      '<span style="text-decoration: line-through;">$12M FDV</span>'
    );
  };

  if (!visible || !currentPopup) return null;

  return (
    <div className={styles.modalOverlay}>
      <div
        className={`${styles.modal} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
      >
        <button className={styles.closeButton} onClick={handleClose}>
          ×
        </button>
        <h2 className={styles.title}>IDO Completed</h2>
        <div className={styles.content}>
          <div
            style={{ whiteSpace: "pre-line" }}
            dangerouslySetInnerHTML={{ __html: formatText(currentPopup.value) }}
          />
        </div>
        <div className={styles.buttons}>
          <Button className={styles.okButton} onClick={handleRedirect}>
            Claim Your Spot
          </Button>
        </div>
      </div>
    </div>
  );
};

export default IdoCompleteModal;
